export const BULK_ACTIONS = {
    CREATE: "CREATE",
    DOWNLOAD: "DOWNLOAD",
    UPLOAD: "UPLOAD",
    DELETE: "DELETE"
}
export const BULK_UPLOAD_CREATE_TEXTS = {
    type: "CREATE",
    title: "Teslimat Şablonu Oluştur",
    description: "Ürün eklemek için toplu ürün şablonu oluşturmadan önce teslimat şablonu oluşturmalısınız.",
    icon: "bulk-create@2x.png",
    buttonText: "Teslimat Şablonu Oluştur",
    info: ""
};
export const BULK_UPLOAD_DOWNLOAD_TEXTS = {
    type: "DOWNLOAD",
    title: "Toplu Ürün Ekleme Şablonu İndir",
    description: "Eklemek istediğiniz ürünlerin kategorilerini seçerek şablon oluşturun.",
    icon: "bulk-download@2x.png",
    buttonText: "Şablon Oluşturmaya Başla",
    info: ""
};
export const BULK_UPLOAD_UPLOAD_TEXTS = {
    type: "UPLOAD",
    title: 'Şablon Dosyasını Yükle',
    description: "Doldurduğunuz toplu ürün şablonunu yüklemek için bilgisayarınızdan seçin veya sürükleyip bırakın.",
    icon: "bulk-upload@2x.png",
    buttonText: "Dosya Seç",
    info: "Dosya <span>.xlsx formatında</span> ve <span>en fazla 15 MB</span> boyutunda olmalıdır."
};

export const BULK_UPDATE_DOWNLOAD_TEXTS = {
    type: "DOWNLOAD",
    title: "Güncelleme Şablonu İndir",
    description: "Şablon türü ve ürün grubunu seçerek  güncellemek istediğiniz bilgiler için şablon oluşturun.",
    icon: "bulk-download@2x.png",
    buttonText: "Şablon İndir",
    info: ""
};

export const BULK_UPDATE_UPLOAD_TEXTS = BULK_UPLOAD_UPLOAD_TEXTS;

export const BULK_DELETE_DOWNLOAD_TEXTS = {
    type: "DOWNLOAD",
    title: "Ürün Silme Şablonu İndir",
    description: "Silmek istediğiniz ürünler için şablon oluşturun.",
    icon: "bulk-delete@2x.png",
    buttonText: "Şablon İndir",
    info: ""
};

export const BULK_DELETE_UPLOAD_TEXTS = BULK_UPLOAD_UPLOAD_TEXTS;

export const BULK_HISTORY_STATUS = {
    WAITING: 'WAITING',
    PROCESSING: 'PROCESSING',
    FINISHED_SUCCESS: 'FINISHED_SUCCESS',
    FINISHED_FAIL: 'FINISHED_FAIL',
    IN_QUEUE: 'IN_QUEUE',
    PROCESSED: 'PROCESSED',
    REJECT: 'REJECT',
};

export const BULK_DEAL_STATUS = {
    DOWNLOADED: 'DOWNLOADED',   
    FAILED_TO_DOWNLOAD: 'FAILED_TO_DOWNLOAD',
    WAITING_FOR_DOWNLOAD: 'WAITING_FOR_DOWNLOAD',
};
  